import { readCircuitKey } from "./readCircuitKey";
import type { BuildCircuitKeyMap, CircuitKeyMap } from "./types";

export const buildCircuitKeyMap: BuildCircuitKeyMap = ({ steps }) => {
  const keys: CircuitKeyMap = {};
  for (const assignment of steps.assignments) {
    for (const circuit of assignment.circuits) {
      // One circuit can appear under two boards; the first entry is the one
      // `routeWhy` reads it by, so the row cannot disagree with Karl's card.
      if (circuit.circuitId in keys) continue;
      keys[circuit.circuitId] = readCircuitKey({ circuit });
    }
  }
  return keys;
};
